export default {
  PAYMENT_STATUS: {
    IN_PROGRESS: 'IN_PROGRESS',
    ACCEPTED: 'ACCEPTED',
    CANCELED: 'CANCELED',
  },
};
